// src/components/practice/Sparkline.jsx
//
// The progress line (lesson-3c-marksheet): every gradeable mark in a redrafted
// prompt, in order, as a tiny SVG. Geometry comes from the pure sparklineGeometry()
// helper (essayProgress.js), so the ordinal -> coordinate mapping is unit-tested and
// this file only draws it.
//
// The end dot turns --success when the run is RISING; a flat or falling run keeps the
// neutral accent, because a dip must never be marked as a failure -- the same
// wellbeing rule the rest of the Progress card follows.
//
// Decorative: the bands beside it already say the same thing in words, so it is
// aria-hidden rather than given a label that would double-read for a screen reader.
import React from 'react';
import { sparklineGeometry } from '../../storage/essayProgress.js';

export const SPARK_W = 56;
export const SPARK_H = 18;

export default function Sparkline({ series, rising, width = SPARK_W, height = SPARK_H }) {
    const { points, d } = sparklineGeometry(series, width, height, 3);
    // One point is not a line; the row's "first -> latest" text covers that case.
    if (points.length < 2) return null;
    const end = points[points.length - 1];
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}
            className="flex-shrink-0 overflow-visible" aria-hidden="true" focusable="false">
            <path d={d} fill="none" stroke="rgb(var(--accent))" strokeWidth="1.5"
                strokeLinecap="round" strokeLinejoin="round" />
            <circle cx={end.x} cy={end.y} r="2.5"
                fill={rising ? 'rgb(var(--success))' : 'rgb(var(--accent))'} />
        </svg>
    );
}
